import {
  FaUserMd,
  FaSpa,
  FaClipboardCheck,
  FaStar,
  FaHeart,
  FaBurn,
  FaLeaf,
  FaSmile,
  FaSmileBeam,
  FaMoneyBill,
  FaRupeeSign,
  FaHome,
} from "react-icons/fa";
import "./HomePageContent.css";
import spahome from "./spahome.jpg";
import BookingComponent from "../Our Treatments 2/BookNow/BookNowCall";
import HomePageCardFor from "./HomePageCardFor";

const HomePageContent = () => {
  return (
    <div className="container mt-2 mb-3">
      <div className="py-5">
        <div className="container">
          <h3 className=" mb-5 Home-page-header">
            Welcome to <strong>Shrikrishna Arogyam Massage Therapy</strong> - A
            Trusted Name Among <strong>Spas in Pune</strong>
          </h3>
          <div className="row align-items-center">
            {/* Left Section */}
            <div className="col-lg-6">
              <h1 className="mt-3 fw-bold text-dark"></h1>
              <p className="text-muted intro">
                At <b>Shrikrishna Arogyam Massage Therapy</b>, among the most
                known and admired <b>Spas in Pune</b>, it's our firm belief that
                wellness is your birth right and not a god-gifted luxury you
                indulge in occasionally. We are today in a world where speed
                matters. And like everything speedy, things wear out fast. As
                one of the leading Spa and massage, it's thus our mission to
                provide you with just the right mix of relaxation, rejuvenation
                and revitalisation. Whether you're dealing with chronic fatigue
                or simply seeking emotional balance, our treatments are designed
                to bring harmony to your entire being. And we do that with the
                widest range of therapies, both traditional and modern.
                <br />
                <br />A massage isn't just about relaxation and therapies. It's
                about life. You could be struggling with stress and tension,
                aches and pains all over the body, or simply looking for an
                escape into peace, tranquillity and just the right touch. We
                provide you with all that at the hands of our trained
                therapists, whether at our therapy centre or through{" "}
                <b>Home Massage Services in Pune</b>, one of the best and most
                prolific anywhere in Pune. Either way, what you get is a highly
                personalised experience at the hands of experts that helps bring
                life back into you.
              </p>
            </div>

            {/* Right Section */}
            <div className="col-lg-6 text-center position-relative">
              <img
                src={spahome}
                alt="Presentation"
                className="img-fluid rounded shadow-lg"
                height={"100%"}
              />
            </div>
          </div>
        </div>
      </div>
      <HomePageCardFor />
      <h2 className="my-5 Home-page-header">
        Experience the Power of Healing Touch
      </h2>
      <div className="row mb-3">
        <p style={{ fontSize: "1.1rem" }}>
          Our spa or <b>Massage Services at Home in Pune</b> are designed to
          bring peace and tranquillity to every cell in your body. While it's
          impossible to cut yourself completely off from the noise and chaos we
          call life, our vast and varied kinds of Spa and Massage services are
          designed to take you to another plane that rejuvenates body, mind, and
          spirit. From ultra-relaxing aromatherapy sessions to focused
          therapeutic massages, all our massages and spa treatments are
          thoughtfully created to restore your natural energy and vitality
          through holistic well-being.
          <br />
          <br /> Being specialists in the field of relaxing massages, we begin
          with a detailed yet quick understanding of our visitor's physical
          concerns and preferences. Be it general body stiffness, fatigue, or
          emotional stress, our experienced staff can adapt each form and
          methodology to suit your needs and comfort level to bring maximum
          benefits, including relaxation and revitalisation.
        </p>
      </div>
      <h2 className=" mt-4 mb-4 Home-page-header">
        Why Choose Shrikrishna Arogyam Among the Many Spas in Pune?
      </h2>
      <p className="mb-4" style={{ fontWeight: "bold", fontSize: "1.1rem" }}>
        When it's about best Spa in Pune, we stand out, given our unwavering
        stand on quality, hygiene, and personalised care. What makes us a
        preferred choice includes factors like:
      </p>
      <div className="row">
        {[
          {
            icon: <FaUserMd />,
            title: "Experienced Personnel",
            text: "Our staff consist of trained and experienced therapists whose range of skills includes deep tissue, Ayurvedic, reflexology, and more.",
          },
          {
            icon: <FaSpa />,
            title: "Clean and Peaceful Environment: ",
            text: "If massages are about peace and tranquillity, what do you think should be the environs? Clean, sanitised and peaceful to imbibe safety and relaxation from the therapy's start to end.",
          },
          {
            icon: <FaClipboardCheck />,
            title: "Tailored Massages",
            text: "We tailor every massage session so as to suit the need and lifestyle of our patrons.",
          },
          {
            icon: <FaStar />,
            title: "Best Quality Oils & Products",
            text: "Relaxation is about using the right things in the right place, like oils and creams from the best Ayurvedic Spa in Pune. As the foremost, it's a given that we use the best products every time.",
          },
          {
            icon: <FaRupeeSign />,
            title: "Affordable Luxury",
            text: "We believe relaxation, peace and happiness is everyone's birth right. While Spas at Kothrud in Pune talk about providing the same, it's only us who do it all the way, right from competitive pricing and zero compromise on quality.",
          },
        ].map((item, index) => (
          <div className="col-md-6" key={index}>
            <div className="card custom-card shadow-sm mb-4">
              <div className="card-body text-center">
                <div className="icon-container">{item.icon}</div>
                <h5 className="card-title homeqq-page-icon">{item.title}</h5>
                <p className="card-text benefit-text">{item.text}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <h2 className=" mt-4 mb-4 Home-page-header">
        Bringing Wellness to Your Doorstep
      </h2>
      <div className="row mb-3">
        {[
          {
            icon: <FaHome />,
            title: "Home Massage Services in Pune",
            text: "Being a full-service Massage Therapy Centre, we serve clients everywhere. Whether our spas at Kothrud in Pune or professional Body Massage Home Services in Pune, we do both equally efficiently. For home massages, our mobile therapy services are just a call away and provide you with the same quality and care as our centre.",
          },

          {
            icon: <FaSmile />,
            title: "The Best Couple Spa in Pune",
            text: "We are the best couple spa situated at Kothrud in Pune. If you are looking for one, we are just a phone call away.Our couple spa packages offer a shared experience of peace and togetherness. For anniversaries, special days, or just quality time with a loved one, you get it all in a private, calm, and comforting environment in the Spas in Pune.",
          },
          {
            icon: <FaLeaf />,
            title: "Your Destination for Full Body Massage in Pune",
            text: "A Full Body Massage at our centre is beyond pampering. Aside from being therapeutic, it promotes sleep, reduces anxiety, improves circulation, and brings better immunity. At Shrikrishna Arogyam, we offer a full range of body massage options that cater to your needs, from pain relief to post-workout recovery to pure relaxation. Every touch by our therapists is meant to relieve knots, restore muscle tone, and refresh your senses.",
          },
          {
            icon: <FaStar />,
            title: "Rated Among the Best Body Massage Centres in Pune",
            text: "We are among the Best Massage Centres situated at Kothrud in Pune, with a reputation built on genuine care,tailored services, and, most of all, positive client feedback. As one of the best Massage Centres in Pune, we have dedicated ourselves to enhancing the quality of your life through natural healing and a client-only approach.",
          },
        ].map((item, index) => (
          <div className="col-md-6" key={index}>
            <div className="card benefit-card shadow-sm mb-4">
              <div className="card-body text-center">
                <div className="icon-container ">{item.icon}</div>
                <h5 className="card-title homeqq-page-icon">{item.title}</h5>
                <p className="card-text benefit-text">{item.text}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <h2 className="Home-page-header">
        Visit Us Today - Because You Deserve It
      </h2>
      <p style={{ fontSize: "1.1rem" }}>
        As life gets busy, does your health take a backseat? If it seems so,
        come to <b>Shrikrishna Arogyam Massage Therapy</b> as we are the leading <b>Spas
        in Pune</b>, where you can relax, recharge, and bounce back from all that
        life throws you.
      </p>
      <p className="mb-4" style={{ fontSize: "1.1rem" }}>
        From quiet solo sessions to a rejuvenating couple spa or the convenience
        of an at-home massage, we're here to serve you - with care, commitment
        and quality. Our reach extends all the way into <b> Kothrud, Karve Nagar,
        Deccan, Baner, Balewadi, Aundh, Panchvati, Wakad, Hinjewadi, Pimple
        Nilakh, Tathawade, Mahalunge, Sus, Pashan, Punawale, and PCMC in Pune.</b>
      </p>
 

      {/* <hr
        style={{
          width: "40%",
          display: "flex",
          margin: "auto",
          height: "2px",
          backgroundColor: "#000",
          // marginTop: "50px",
        }}
      /> */}
      <BookingComponent />
    </div>
  );
};

export default HomePageContent;
